// Confirmation modal for task deletion — MUI Dialog with i18n and design tokens.
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { useT } from '@/i18n/useT';

const DeleteConfirmDialog = ({ open, onClose, onConfirm }) => {
  const t = useT();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      role="alertdialog"
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>
        {t('confirm.delete.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText color="text.secondary">
          {t('confirm.delete.body')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={onClose} color="inherit">
          {t('confirm.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disableElevation
        >
          {t('confirm.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
